const formErrorRules = (name: string) => {
    switch (name) {
        case "email":
            return {
                required: true,
                pattern: {
                    value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                    message: "Zkontrolujte, zda jste e-mail zadali správně."
                }
            }
        case "phoneNumber":
            return {
                required: true,
                pattern: {
                    value: /^\+420\s\d{3}\s\d{3}\s\d{3}$/,
                    message: "Špatný formát čísla. Vložte v formátu +420 123 123 123"
                }
            }
        case "pin":
            return {
                required: true,
            }
        case "account":
            return {
                required: true,
            }
    }
}

export {
    formErrorRules
}
